import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  @Input() companyName;
  currentYear;

  today = null;
  totalWebVisits = 0;
  myAccummulate = 0;

  constructor(private router: Router) {
    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    var accumulate = 30*month+day;
    this.today = year + "/" + month + "/" + day;
    this.totalWebVisits = accumulate + this.myAccummulate;
    this.currentYear =dateObj.getUTCFullYear();
  }


  goToFunnel() {
    this.router.navigateByUrl('/funnel');
  }

  goToContactPage() {
    this.router.navigateByUrl('/contact');
  }

  goToTravelersPage() {
    this.router.navigateByUrl('/travelers-page');
  }

  ngOnInit(): void {

  }

  getNumber() {
    return this.totalWebVisits;
  }

}
